import { Playground } from 'docz';
import DemoBlock from "../../../../../src/components/DemoBlock/DemoBlock.tsx";
import IconMap from "../../../../../src/components/Icon/IconMap.ts";
import Icon from "../../../../../src/components/Icon/icon.tsx";
import * as React from 'react';
export default {
  Playground,
  DemoBlock,
  IconMap,
  Icon,
  React
};